import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: 'row',
    marginBottom: scale(20),
  },
  itemContent: {
    flex: 1,
  },
  itemTitle: {
    marginBottom: scale(2),
  },
  itemDescription: {
    marginTop: scale(2),
  },
  itemTime: {
    marginTop: scale(8),
  },
  listContentContainer: {
    flexGrow: 1,
    paddingBottom: scale(8),
  },
  paginationLoaderContainer: {
    alignItems: 'center',
    paddingBottom: scale(12),
    paddingTop: scale(4),
  },
  markAllReadText: {
    color: colors.secondary.orchid,
  },
  markAllReadTextDisabled: {
    color: colors.disabled.smoke,
  },
  sectionDot: {
    backgroundColor: colors.primary.carnation,
    borderRadius: scale(4),
    height: scale(8),
    marginRight: scale(10),
    marginTop: scale(6),
    width: scale(8),
  },
  sectionDotPlaceholder: {
    marginRight: scale(18),
    width: 0,
  },
  sectionHeader: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: scale(12),
  },
  sectionTitle: {
    color: colors.neutral.darkMist,
  },
});

export default styles;
